var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"spline-c3"},[_c('vue-c3',{attrs:{"handler":_vm.splinecharthandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }